import React, { useRef } from 'react';
import AdvancedDirectivePrint from '../Pages/Forms/Print/AdvancedDirectivePrint';
import HipaaConsentPrint from '../Pages/Forms/Print/HipaaConsentPrint';
import OlderCarePrint from '../Pages/Forms/Print/OlderCarePrint';
import PatientIntakePrint from '../Pages/Forms/Print/PatientIntakePrint';
import PatientSurveyPrint from '../Pages/Forms/Print/PatientSurveyPrint';
import DotPhysicalPrint from '../Pages/Forms/Print/DotPhysicalPrint';
import ImmunizationPrint from '../Pages/Forms/Print/ImmunizationPrint';
import InvoicePrint from '../Pages/InvoicePrint';
import { Drawer } from 'vaul';

export default function FormViewDetailsModal({ ...props }) {
  const {    
    formId,
    formSize = "A4",
    formView = false,
    setFormView = () => {},
    formType,
    filterData = {},
    reloadFunction = () => {},
    previousScrollPosition = 0,
  } = props; 
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setFormView(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={formView} onOpenChange={handleDrawerClose}>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Form View</Drawer.Title>
            <Drawer.Description className="sr-only">View a form details</Drawer.Description>
            <div className={`docpro_modal_wrap docpro_style_1 docpro_modal_lg`}>
              <div className="docpro_modal" style={{ maxWidth: '100%', position: 'unset' }}>
                {formType === 'advanced_directive' ? (
                  <AdvancedDirectivePrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'hipaa_consent' ? (
                  <HipaaConsentPrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'older_care' ? (
                  <OlderCarePrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'patient_intake' ? (
                  <PatientIntakePrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'patient_survey' ? (
                  <PatientSurveyPrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'dot_physical' ? (
                  <DotPhysicalPrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'immunization' ? (
                  <ImmunizationPrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                  />
                ) : formType === 'invoice' ? (
                  <InvoicePrint 
                    formViewId={formId}
                    formViewSize={formSize}
                    setFormView={handleDrawerClose}
                    filterData={filterData}
                    reloadFunction={reloadFunction}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}